import { taskCategoriesRead, taskCategoryAdd, taskCategoryUpdate, taskCategoryDelete } from "../api";
import { dataSuccess, dataFailure } from "./general";

export const FETCH_TASK_CATEGORIES_SUCCESS = "FETCH_TASK_CATEGORIES_SUCCESS"
export const ADD_TASK_CATEGORY = "ADD_TASK_CATEGORY"
export const UPDATE_TASK_CATEGORY = "UPDATE_TASK_CATEGORY"
export const DELETE_TASK_CATEGORY = "DELETE_TASK_CATEGORY"
export const SET_SELECTED_TASK_CATEGORY = "SET_SELECTED_TASK_CATEGORY"

const fetchTaskCategoriesSuccess = (values) => {
  return {
    type: FETCH_TASK_CATEGORIES_SUCCESS,
    payload: values
  }
}

export const fetchTaskCategories = (values) => {
  return async (dispatch) => {
    try {
      const returnJSONData = await dispatch(taskCategoriesRead(values))
      await dispatch(fetchTaskCategoriesSuccess(returnJSONData))
    } catch(err) {
      await dispatch(dataFailure(err.message))
    }
  }
}

const addTaskCategoryData = (values) => {
  return {
    type: ADD_TASK_CATEGORY,
    payload: values,
  };
};

export const addTaskCategory = (values) => {
  return async (dispatch) => {
    try {
      const returnJSONData = await dispatch(taskCategoryAdd(values));
      await dispatch(addTaskCategoryData({...values, id: returnJSONData}));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const updateTaskCategoryData = (values) => {
  return {
    type: UPDATE_TASK_CATEGORY,
    payload: values,
  };
};

export const updateTaskCategory = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(taskCategoryUpdate(values));
      await dispatch(updateTaskCategoryData(values));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};



const deleteTaskCategoryData = (values) => {
  return {
    type: DELETE_TASK_CATEGORY,
    payload: values,
  };
};

export const deleteTaskCategory = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(taskCategoryDelete(values));
      await dispatch(deleteTaskCategoryData(values));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

export const setSelectedTaskCategory = (values) => {
  return {
    type: SET_SELECTED_TASK_CATEGORY,
    payload: values,
  };
};
